import { get, intersection, each, isArray } from 'lodash';

export const checkGeneralPermition = (permissions, required) => {
  if (!required) return true;
  const permission = get(permissions, `${required}`, {});
  return get(permission, 'allowed', false) === true;
};

export const checkSubscribedFeaturePermissions = (subscribedPlan, feature) => {
  if (!feature) return true;
  const limitReached = get(subscribedPlan, `${feature}.limit_reached`);
  return limitReached || false;
};

export const checkScopesPermition = (permissions, required) => {
  if (!required) return true;
  const match = intersection(permissions, required);
  return match && match.length > 0;
};

export const checkRequiredSubscribedFeature = (feature, subscribedPlan) => {
  let valid = false;

  if (isArray(feature)) {
    let checked = 0;

    each(feature, (item) => {
      const check = get(subscribedPlan, item);
      if (check) checked += 1;
    });

    valid = checked > 0;
  } else {
    valid = feature ? get(subscribedPlan, feature) : true;
  }

  return valid;
};

export const checkPageRequiredSubscribedFeature = (page, subscribedPlan) => {
  const feature = get(page, 'requiredSubscribedFeature', false) || false;
  return checkRequiredSubscribedFeature(feature, subscribedPlan);
};

export const checkScopesPermitionAndRequiredSubscribedFeature = (permissions, requiredPermissions, feature, subscribedPlan) => {
  const haveScope = checkScopesPermition(permissions, requiredPermissions);
  if (!haveScope) return false;

  const haveRequiredSubscribedFeature = checkRequiredSubscribedFeature(feature, subscribedPlan);
  return haveScope && haveRequiredSubscribedFeature;
};



// WEBPACK FOOTER //
// ./src/utils/check-permissions.js